const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    black: '#000',
    white: '#fff',
    gray: {
        0: '#FFFFFF',
        50: '#F2F6F7',
        100: '#D9E3E9',
        // @deprecated
        150: '#C3D4DE',
        200: '#C3D4DE',
        // @deprecated
        250: '#98B6C9',
        300: '#98B6C9',
        // @deprecated
        350: '#7399AF',
        400: '#7399AF',
        // @deprecated
        450: '#58798F',
        500: '#58798F',
        // @deprecated
        550: '#465B6B',
        600: '#465B6B',
        700: '#3D4852',
        800: '#2A3238',
        900: '#000000',
    },
    red: {
        100: '#FEE7E2',
        200: '#F4C3BF',
        300: '#E6A2A2',
        400: '#D96F7E',
        500: '#D33A61',
        600: '#A52251',
        700: '#801248',
    },
    orange: {
        100: '#feedde',
        200: '#ffc48c',
        300: '#f68d2e',
        400: '#db781c',
        500: '#b35f11',
        600: '#8c4400',
    },
    yellow: {
        100: '#FFFDA9',
        200: '#FFFB7B',
        300: '#F2DD06',
        400: '#D6C212',
        500: '#A5941E',
        600: '#86751C',
        700: '#685714',
    },
    green: {
        100: '#D1F6CF',
        200: '#A1E8A5',
        300: '#53CE73',
        400: '#2BA95C',
        500: '#1B8756',
        600: '#146459',
        700: '#004F49',
    },
    blue: {
        100: '#CBF3FE',
        200: '#98D7FC',
        300: '#64BBFA',
        400: '#4791FF',
        500: '#2C72DE',
        600: '#1D52BA',
        700: '#0F3599',
    },
    purple: {
        100: '#EBDEFF',
        200: '#DAC4FF',
        300: '#C2A4FF',
        400: '#A37BFB',
        500: '#8552F6',
        600: '#5F36D3',
        700: '#321C9C',
    },
};
export default { ...colors, neutral: { ...colors.gray } };
//# sourceMappingURL=colors.js.map